







































































import Vue from 'vue';
import Logo from '../layout/Logo.vue';
import RegisterCard from './RegisterCard.vue';

export default Vue.extend({
  meta: {
    title: 'Registration',
  },
  components: {
    logo: Logo,
    'register-card': RegisterCard,
  },
});
